import { connect } from 'react-redux';
import TokenListed from './TokenListed'
import './TokenListed.css'
import { submitListingRequest } from '../../redux/actions/tokenform'

const mapStateToProps = state => ({})
const mapDispatchToProps = { submitListingRequest }

export default connect(mapStateToProps, mapDispatchToProps)(TokenListed)
